export const SET_INCOME_360PAY = "SET_INCOME_360PAY";
